import { completedIndexOf, galleryVerdict, grouped, tokensUpTo, } from "./grades";
// Any field change re-solves once typing settles.
export const GALLERY_PLAN_DEBOUNCE_MS = 500;
export const GALLERY_PLAN_LIMITS = [
    "targetTokens",
    "budget",
    "maxTaxLoss",
    "maxTransfers",
    "maxSets",
];
/** "10k", "1.5m", "12,500": a whole number, or undefined for empty or unreadable. */
export const parseAmount = (text) => {
    const match = /^(\d*\.?\d+)([km]?)$/.exec(text.replace(/[,\s]/g, "").toLowerCase());
    if (!match)
        return undefined;
    const scale = match[2] === "m" ? 1e6 : match[2] === "k" ? 1e3 : 1;
    return Math.round(Number(match[1]) * scale);
};
/** Whole numbers get thousands commas; "10k" and "1.5m" stay as typed. */
export const formatAmountInput = (value) => {
    const text = value.replace(/[^\d.,kmKM]/g, "");
    const digits = text.replace(/,/g, "");
    return /^\d+$/.test(digits) ? grouped.format(Number(digits)) : text;
};
export const planFieldsOf = (input) => Object.fromEntries(GALLERY_PLAN_LIMITS.map((k) => [
    k,
    input?.[k] === undefined ? "" : grouped.format(input[k]),
]));
export const planValuesOf = (fields) => Object.fromEntries(GALLERY_PLAN_LIMITS.map((k) => [k, parseAmount(fields[k])]));
/** Keyed on the parsed limits, so "10k" and "10000" are one build. */
export const planKeyOf = (limits, categoryId) => JSON.stringify([
    GALLERY_PLAN_LIMITS.map((k) => limits[k] ?? null),
    categoryId ?? null,
]);
/** The whole plan's verdict, plus why it falls short of the Tokens target. */
export const describeGalleryPlan = (plan, empty) => {
    const verdict = !plan
        ? undefined
        : plan.totals.tokens > 0
            ? galleryVerdict(plan.totals.taxLoss / plan.totals.tokens)
            : "bad";
    return {
        verdict,
        nothingToBuy: !!plan && plan.totals.transfers === 0 && plan.totals.tokens > 0,
        tokenWarning: empty
            ? { key: "plan.empty" }
            : plan && !plan.targetReached
                ? {
                    key: "plan.maxTokens",
                    tokens: grouped.format(plan.totals.tokens),
                }
                : undefined,
    };
};
/**
 * What the user completed of a plan since it was built: the planned sets
 * completed up to their planned grade, and the tokens earned towards them.
 */
export const galleryPlanDone = (plan, sets, progress) => {
    const byId = new Map(sets.map((s) => [s.id, s]));
    let tokens = 0;
    let setsDone = 0;
    for (const { setId, grade } of plan.sets) {
        const set = byId.get(setId);
        if (!set)
            continue;
        const planned = set.grades.findIndex((g) => g.name === grade);
        const now = completedIndexOf(set.grades, progress.get(setId)?.completedGrade);
        const atBuild = completedIndexOf(set.grades, plan.completedAtBuild[setId]);
        tokens += Math.max(0, tokensUpTo(set.grades, Math.min(now, planned)) -
            tokensUpTo(set.grades, atBuild));
        if (now >= planned)
            setsDone++;
    }
    return { tokens, sets: setsDone };
};
//# sourceMappingURL=planner.js.map